module.exports = __webpack_public_path__ + "img/manage-upload-icon.190f87ff.svg";